// frontend/src/App.tsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthContext";
import { BrandingProvider } from "./contexts/BrandingContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppBar from "./components/ui/AppBar";
import HomePage from "./pages/HomePage";
import JoinQueuePage from "./pages/JoinQueuePage";
import QueueStatusPage from "./pages/QueueStatusPage";
import LoginPage from "./pages/admin/LoginPage";
import RegisterPage from "./pages/admin/RegisterPage";
import DashboardPage from "./pages/admin/DashboardPage";
import CreateEventPage from "./pages/admin/CreateEventPage";
import EventQueuePage from "./pages/admin/EventQueuePage";
import AdminBrandingPage from "./pages/admin/AdminBrandingPage";
import AdminHistoryPage from "./pages/admin/AdminHistoryPage";
import AdminIntegrationsPage from "./pages/admin/AdminIntegrationsPage";
import OnboardingPage from "./pages/admin/OnboardingPage";
import AdminBillingPage from "./pages/admin/AdminBillingPage";
import PricingPage from "./pages/PricingPage";
import TvDisplayPage from "./pages/admin/TvDisplayPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrandingProvider>
          <BrowserRouter>
            <AppBar />
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/join" element={<JoinQueuePage />} />
              <Route path="/status" element={<QueueStatusPage />} />
              <Route path="/pricing" element={<PricingPage />} />

              {/* Admin routes - Auth */}
              <Route path="/admin/login" element={<LoginPage />} />
              <Route path="/admin/register" element={<RegisterPage />} />

              {/* Admin routes - Protected */}
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />

              {/* Event routes */}
              <Route
                path="/admin/events/create"
                element={
                  <ProtectedRoute>
                    <CreateEventPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/events/:eventId"
                element={
                  <ProtectedRoute>
                    <EventQueuePage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/events/:eventId/tv"
                element={
                  <ProtectedRoute>
                    <TvDisplayPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/events/:eventId/edit"
                element={
                  <ProtectedRoute>
                    <CreateEventPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/history"
                element={
                  <ProtectedRoute>
                    <AdminHistoryPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/branding"
                element={
                  <ProtectedRoute>
                    <AdminBrandingPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/onboarding"
                element={
                  <ProtectedRoute>
                    <OnboardingPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/integrations"
                element={
                  <ProtectedRoute>
                    <AdminIntegrationsPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/billing"
                element={
                  <ProtectedRoute>
                    <AdminBillingPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </BrandingProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
